import { Component, Input, ViewChild } from '@angular/core';
import { NavParams, ModalController, PopoverController } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { NavController } from 'ionic-angular';
import { LocationsProvider } from '../../providers/locations/locations';
import { CoLocationComponent } from '../co-location/co-location';
import { CallNumber } from '@ionic-native/call-number';
import { Platform } from 'ionic-angular'
import { HttpClient } from '@angular/common/http';
import { LaunchNavigator } from '@ionic-native/launch-navigator';
import { CoMapPage } from '../../pages/co-map/co-map';
import { AppState } from '../../config/state';
import moment from 'moment';
import { CoEmailInputComponent } from '../co-email-input/co-email-input';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';

/**
 * Generated class for the CoLocationsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-locations',
  templateUrl: 'co-locations.html'
})
export class CoLocationsComponent {

  allLocations: any = [];
  searchLocations: any = [];
  currentPosition: any;
  currentDay: number;
  listType: string;
  nearestLocation: string;
  loadPage: boolean = false;
  modal: any;
  todayDay: any = moment().startOf('day').day();
  tomorrowDay: any = moment().startOf('day').add(1, 'day').day();
  couldGetLocation: boolean = false;
  singleBranch: boolean = false;
  singleBranchLocationId: number;
  @ViewChild('locationSearch') locationSearch;
  @Input('blockSettings') blockSettings: any;
  constructor(public navParams: NavParams, public locationsProvider: LocationsProvider, private toast : ToastAlertsProvider, public config: ConfigProvider, public navCtrl: NavController, private callNumber: CallNumber, private platform: Platform, private launchNavigator: LaunchNavigator, public modalCtrl: ModalController, public state: AppState, public httpClient: HttpClient, private popoverCtrl: PopoverController) {}
  ngOnInit() {
    let self = this;
    this.locationsProvider.getLocations().then(function (res) {
      let response = res.filter(l => l.appViewable === 1);
      if(response.length === 1) {
        self.singleBranch = true;
        self.singleBranchLocationId = response[0].id;
        return;
      }
      response.map((location) => {
        if (location.phone[3] === " ") {
          let splitNum = location.phone.split(' ');
          let rejoinNum = [];
          rejoinNum.push(`(${splitNum[0]}) `, splitNum[1], `-${splitNum[2]}`);
          return location.phone = rejoinNum.join('');
        } else if (location.phone[3] === '-') {
          let splitNum = location.phone.split('-');
          let rejoinNum = [];
          rejoinNum.push(`(${splitNum[0]}) `, splitNum[1], `-${splitNum[2]}`);
          return location.phone = rejoinNum.join('');
        } else {
          location.phone = location.phone;
        }
      });
      self.allLocations = response;
      self.searchLocations = response;
      self.locationsProvider.getUserLocation().then((res) => {
        if (res && res.lat === "" && res.lng === "") {
          self.listType = "alphabetical";
          self.listChange();
        } else {
          self.currentPosition = res;
          self.couldGetLocation = true;
          self.getDistances();
        }
      }).catch(err =>{
        self.listType = "alphabetical";
        self.listChange();
      });
    });
    this.currentDay = moment().day();
  }
  emailInfo(branch) {
    let popover = this.popoverCtrl.create(CoEmailInputComponent, {}, {cssClass: 'custom-email-input-popover'});
    popover.present();
    popover.onDidDismiss((data) => {
      if (data && data.info) {
        this.locationsProvider.emailBranchInfo(branch, data.info).then((notification) => {
          if (notification && notification.length > 0 && notification[0].status) {
            this.toast.showAlert("", "Successfully sent location", "success");
          } else {
            this.toast.showAlert("", "Failed to send location to this email address.");
          }
        })
      }
    });
  }

  toggleSearch() {
    let element = this.locationSearch.nativeElement;

    if (element.classList.contains("searchBar")) {
      element.classList.remove('searchBar')
      element.classList.add('searchBarShow');
    }
    else {
      element.classList.remove('searchBarShow')
      element.classList.add('searchBar');
    }

    this.filterLocations('');
  }

  getDistances() {
    let i = 0;
    this.searchLocations.forEach(element => {
      var radlat1 = Math.PI * this.currentPosition.lat / 180;
      var radlat2 = Math.PI * this.searchLocations[i].locationLatitude / 180;
      var theta = this.currentPosition.lng - this.searchLocations[i].locationLongitude;
      var radtheta = Math.PI * theta / 180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      this.searchLocations[i].distance = dist.toFixed(1);
      i++;
    });

    this.listType = "nearest";
    this.listChange();
  }

  goToLocation(locationId: any) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoLocationComponent, { location: locationId, showNavbar: true });
    });
  }


  call(number: string) {
    this.callNumber.callNumber(number, true)
      .catch(() => console.log('Error launching dialer'));
  }

  filterLocations(term: any) {
    this.searchLocations = this.allLocations;
    if (term == '') {
      return;
    }
    let val = term.target.value;

    for (let i = 0; i < this.searchLocations.length; i++) {
      if (val && val.trim() !== '') {
        this.searchLocations = this.allLocations.filter(function (location) {
          return location.name.toLowerCase().includes(val.toLowerCase());
        });
      }
    }
  }

  openMap(locationAddress: any) {
    this.modal = this.modalCtrl.create(CoMapPage, { data: locationAddress });
    this.modal.present();
  }

  ionViewDidEnter() {

    // setTimeout(this.listChange(), 0);
  }

  listChange() {
    let self = this;
    if (this.listType == "nearest") {
      if (!self.couldGetLocation) {
        self.listType = "alphabetical";
        self.listChange();
        return;
      }
      self.searchLocations.sort(function (a, b) {
        self.loadPage = true;
        return a.distance - b.distance;
      });
      if (!self.nearestLocation && self.couldGetLocation) {
        self.nearestLocation = self.searchLocations[0].name;
      }
    } else if (this.listType == "alphabetical") {
      this.searchLocations.sort(function (a, b) {
        return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'})
      });
      self.loadPage = true;
    }
    self.loadPage = true;
  }

  openDirections(locationAddress: any) {
    if (this.state.mode !== 'desktop' && this.platform.is('cordova')) {
      this.launchNavigator.navigate(locationAddress.fullAddress)
      .then(
        success => alert('Launched navigator'),
        error => alert('Error launching navigator: ' + error)
      );
    } else {
      window.open("//google.com/maps/dir/?api=1&origin=&destination=" + locationAddress.locationLatitude + "," + locationAddress.locationLongitude, "_system");
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-locations/co-locations.ts